<template>
  <div id="app" @mousemove="cursorMove">
    <div id="mouseball" ref="mouseball" class="mouseball">
    </div>
    <world-engine></world-engine>
    <main-transition>
      <router-view/>
    </main-transition>
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/works">Works</router-link> |
      <router-link to="/profile">Profile</router-link>
    </div>
  </div>
</template>
<script>
import MainTransition from '@/transitions/GSAP'
import WorldEngine from '@/components/WorldEngine'
import isMobile from 'ismobilejs';
import { TimelineMax, TweenMax, Power3 } from 'gsap';
export default {
  name: 'App',
  components: {
    WorldEngine,
    MainTransition
  },
  mounted() {
      const {mouseball} = this.$refs
      if (isMobile().any) {
        TweenMax.to(mouseball, 0.15, {
          autoAlpha: 0,
          x: 0,
          y: 0,
        })
      }
  },
  methods:{
    cursorMove() {
      const {mouseball} = this.$refs
      let pos = {
        x: event.clientX,
        y: event.clientY,
      }
      if (!isMobile().any) {
        if(pos.y <= 10 || pos.x <= 10 || (pos.x >= window.innerWidth - 10 || pos.y >= window.innerHeight - 10)) {
          TweenMax.to(mouseball, 0.15, {
            autoAlpha: 0,
          })
        } else {
          TweenMax.to(mouseball, 0.15, {
            autoAlpha: 1,
            x: pos.x - 15,
            y: pos.y - 15,
          })
        }
      }
    }
  },
  watch:{
    $route (to, from){
      const {mouseball} = this.$refs
      let tl = new TimelineMax()
    }
  }
};
</script>

<style src="./styles/base/main.styl" lang="stylus">
</style>
